import React from 'react'
import PropTypes from 'prop-types'

import IconButton from 'components/Utils/IconButton'
import { ShrinkIcon, ExpandIcon } from 'components/Utils/Icons'

const NOTE_HEADER_HEIGHT = 64

class ChangeLayoutConfiguration extends React.PureComponent {
  static propTypes = {
    hideNoteMetaPanel: PropTypes.func.isRequired,
    isDetachedMode: PropTypes.bool.isRequired,
    isOnboardingActive: PropTypes.bool.isRequired,
  }

  handleClick = () => {
    const {
      isSidebarCollapsed,
      isMetaPanelOpen,
      uncollapseSidebar,
      collapseSidebar,
      hideNoteMetaPanel,
    } = this.props
    if (isMetaPanelOpen) {
      hideNoteMetaPanel()
      return
    }
    isSidebarCollapsed ? uncollapseSidebar() : collapseSidebar()
  }

  render() {
    const {
      isDetachedMode,
      isOnboardingActive,
      isSidebarCollapsed,
      isMetaPanelOpen,
    } = this.props
    if (isOnboardingActive || isDetachedMode || isMetaPanelOpen) {
      return false
    }
    return (
      <div
        className="position-absolute flexbox flexbox-centered zindex-small"
        style={{
          height: NOTE_HEADER_HEIGHT,
          width: NOTE_HEADER_HEIGHT,
          userSelect: 'none',
        }}
      >
        <div onClick={this.handleClick}>
          <IconButton>
            {isSidebarCollapsed || isMetaPanelOpen ? (
              <ShrinkIcon size={16} />
            ) : (
              <ExpandIcon size={16} />
            )}
          </IconButton>
        </div>
      </div>
    )
  }
}

export default ChangeLayoutConfiguration
